<template>
  <div class="content">
    <el-form :inline="true" style="margin: 20px 0">
      <!-- <el-button class="addBtn" type="primary" size="small" @click="handleAdd"
        >新增</el-button
      >-->
      <el-form-item label="用户姓名: " style="margin: 0 20px" size="small">
        <el-input v-model="listQuery.username" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="getListData" size="small">搜索</el-button>
    </el-form>
    <!-- 分类表格 -->
    <el-table
      border
      :data="tableData"
      style="width: 100%; overflow-y: scroll !important"
      height="calc(100vh - 220px)"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-text="正在加载中"
    >
      <el-table-column type="index" label="序号" align="center" width="100"></el-table-column>
      <!-- <el-table-column label="护士图" width="120" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 30px; height: 30px; border-radius: 5px"
            :src="scope.row.img"
            :preview-src-list="[scope.row.img]"
          >
          </el-image>
        </template>
      </el-table-column>-->
      <el-table-column label="预约项目" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.project_name ? scope.row.project_name:'-' }}</template>
      </el-table-column>
      <el-table-column label="下单用户" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.username }}</template>
      </el-table-column>
      <el-table-column label="年龄" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.age?scope.row.age:'/' }}</template>
      </el-table-column>
      <el-table-column label="性别" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.sex?scope.row.sex:'/' }}</template>
      </el-table-column>
      <el-table-column label="预约时间" width="220" align="center">
        <template slot-scope="scope">{{ scope.row.productTime + " " + scope.row.productDate }}</template>
      </el-table-column>
      <el-table-column label="预约人数" align="center" width="200">
        <template slot-scope="scope">{{ scope.row.count }}</template>
      </el-table-column>
      <el-table-column label="手机号" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.phone }}</template>
      </el-table-column>
      <el-table-column label="支付金额" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.money }} 元</template>
      </el-table-column>

      <!-- <el-table-column label="地址" align="center">
        <template slot-scope="scope"> {{ scope.row.des }} </template>
      </el-table-column>-->
      <!-- 0 待支付 1已支付 2已核销 -->
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          {{
          scope.row.status == 0
          ? "待支付"
          : scope.row.status == 1
          ? "已支付"
          : "已核销"
          }}
        </template>
      </el-table-column>
      <el-table-column label="地址" align="center" width="300">
        <template slot-scope="scope">{{ scope.row.des }}</template>
      </el-table-column>
      <el-table-column label="修改时间" align="center" width="220">
        <template slot-scope="scope">{{ scope.row.newProductTime ? scope.row.newProductTime : '-' }}</template>
      </el-table-column>
      <el-table-column label="下单时间" align="center" width="200">
        <template slot-scope="scope">{{ scope.row.createTime }}</template>
      </el-table-column>

      <el-table-column label="交易单号" width="320" align="center">
        <template slot-scope="scope">{{ scope.row.transaction_id ? scope.row.transaction_id : "/" }}</template>
      </el-table-column>

      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button size="mini" type="text" @click="handleEdit(scope.row)" primary>修改</el-button> -->
          <el-button
            size="mini"
            type="text"
            style="color: rgb(255, 0, 0)"
            @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 产品提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="dialogForm" label-width="90px">
        <el-form-item label="状态" required>
          <el-input v-model="dialogForm.price" clearable type="number"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" @click="dialogFormVisible = false">取 消</el-button>
        <el-button class="addBtn" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectNurseOrder,
  updateNurseOrder,
  deleteNurseOrder,
  addNurseOrder
} from "@/services/nurse/index";
import { IP } from "@/services/index.js";
export default {
  created() {
    this.getListData();
  },
  data() {
    return {
      listQuery: {
        pageNumber: 1,
        pageSize: 1000,
        total: 0,
        name: ""
      },
      goodsTitle: "",
      tableData: [],
      dialogFormVisible: false,
      dialogForm: {},
      inpitTypeName: "",
      formLabelWidth: "120px",
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: false,
      pageCount: "",
      pageSize: 8,
      form: {
        productNurse: 1
      },
      status: 0
    };
  },
  methods: {
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const { data, code, count } = await selectNurseOrder(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    handleAdd(type) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增";
      this.fileList = [];
      this.dialogForm = {};
      this.isaddNurseOrderselectNurseOrderOne = 1;
    },

    /* 修改 */
    handleEdit(row) {
      this.fileList = [];
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      // if (this.dialogForm.store_id) {
      //   this.dialogForm.store_id = this.dialogForm.store_id?.split(",");
      // }
    },

    handleSuccess_cover(e) {
      this.dialogForm.img = e.data;
    },

    /* 保存 */
    save() {
      //必填字段校验
      if (
        !this.dialogForm.username ||
        !this.dialogForm.phone ||
        !this.dialogForm.detail ||
        !this.dialogForm.price
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      if (this.inpitTypeName == "新增") {
        addNurseOrder({ ...this.dialogForm }).then(res => {
          if (res.code) {
            this.$message({
              type: "success",
              message: "新增成功!"
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
      if (this.inpitTypeName == "修改") {
        updateNurseOrder(this.dialogForm).then(resp => {
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!"
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      console.log(row.id);
      this.$confirm(`此操作将永久删除该数据吗, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteNurseOrder({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.content {
  margin: 20px auto;
  width: 96%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.goodsTitle:hover {
  cursor: pointer;
}

.upload-demo {
  margin: 20px;
}
</style>
